import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Button, Chip, DataGrid, Icon, IconButton, Spacer, Tooltip, Typography } from '@emburse/embark-core';
import { FileDownloadIcon } from '@emburse/embark-icons';
import dayjs from 'dayjs';
import { $t, useTranslation } from '../../../hooks/useTranslation';
function ERPGatewayHistoryExported({ onViewErrors, data, loading, canDownload, hasErrors, onDownloadfile, canShowDetails }) {
    useTranslation();
    const formatStatus = (status) => (_jsxs("div", { style: { width: '100%' }, children: [status.toLowerCase().includes('failed') && (_jsx(Tooltip, { title: $t(`One or more errors occurred during the export. Please review the error details on the 
                        Export Errors tab and make the necessary updates to the reports before attempting to export again.`), placement: "left", children: _jsx(Chip, { label: $t('Failed'), color: "error", size: "mini", variant: "outlined" }) })), status.toLowerCase().includes('noaction') && (_jsx(Tooltip, { title: $t('The export ran successfully, however no expense reports were included with this batch.'), placement: "left", children: _jsx(Chip, { label: $t('No Action'), color: "warning", size: "mini", variant: "outlined" }) })), status.toLowerCase().includes('running') && (_jsx(Chip, { label: $t('Running'), color: "info", size: "mini", variant: "outlined" })), status.toLowerCase().includes('pending') && (_jsx(Chip, { label: $t('Pending'), color: "info", size: "mini", variant: "outlined" })), status.toLowerCase().includes('partial') && (_jsx(Chip, { label: $t('Partial'), color: "info", size: "mini", variant: "outlined" })), status.toLowerCase().includes('completed') && (_jsx(Chip, { label: $t('Completed'), color: "success", size: "mini", variant: "outlined" }))] }));
    const formatUserSchedule = (user) => (user ? 'Manual' : 'Scheduled');
    const downloadDisabled = (status) => status.toLowerCase().includes('failed') ||
        status.toLowerCase().includes('completed') ||
        status.toLowerCase().includes('partial');
    const columns = () => [
        {
            field: 'StartDate',
            headerName: $t('Date'),
            flex: 2,
            renderCell: (cell) => (_jsx(Typography, { variant: "body2", children: `${dayjs(cell.value)
                    .utc(true)
                    .local()
                    .tz(dayjs.tz.guess())
                    .format('ddd L LT')}` }))
        },
        {
            field: 'Config',
            headerName: $t('Type'),
            flex: 2,
            renderCell: (cell) => (_jsx(Typography, { variant: "body2", children: formatUserSchedule(JSON.parse(cell.row.Config)?.InitiatingUserId) }))
        },
        {
            field: 'Status',
            headerName: $t('Status'),
            width: 110,
            renderCell: (cell) => formatStatus(cell.value)
        },
        ...(canDownload
            ? [
                {
                    field: 'ActionPlaceholder',
                    headerName: $t('Details'),
                    width: 65,
                    renderCell: (cell) => (_jsx("div", { style: {
                            width: '100%',
                            textAlign: 'center'
                        }, children: canShowDetails(cell.row.StartDate) && (_jsx(IconButton, { color: "monochrome", size: "medium", title: "Download", disabled: !downloadDisabled(cell.row.Status), onClick: () => {
                                onDownloadfile(cell.row.Id, 'export');
                            }, children: _jsx(Icon, { iconUrl: FileDownloadIcon }) })) }))
                }
            ]
            : [])
    ];
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", children: $t('Exported') }), hasErrors && (_jsxs(_Fragment, { children: [_jsx(Spacer, { size: 30 }), _jsx(Alert, { severity: "error", action: _jsx(Button, { color: "error", onClick: onViewErrors, variant: "text", children: $t('View Errors') }), children: $t('Errors occurred during a recent export. View details on the Export Errors tab.') }), _jsx(Spacer, { size: 30 })] })), _jsx(DataGrid, { autoHeight: true, pageSizeOptions: [5, 10, 100], loading: loading, localeText: {
                    noRowsLabel: $t('Export history logs will appear here once an export is complete.')
                }, rows: data, columns: columns() })] }));
}
export default ERPGatewayHistoryExported;
